/* eslint-disable import/first */
import React, { Component } from "react";
import NavPublic from "../../../nav/NavPublic";
import { render } from "@testing-library/react";
import {
	Navbar,
	Nav,
	NavDropdown,
	Card,
	CardColumns,
	Form,
	Button,
	Row,
	Col,
	Jumbotron,
	Table,
	Tr,
	Td,
	Pagination,
} from "react-bootstrap";
import FormDemande from "../add/formDemande";

class AddDemandePublic extends Component {
	constructor() {
		super();
		this.user = JSON.parse(localStorage.getItem("currentUser"))[
			"data"
		][0].aut_login;
	}
	render() {
		return (
			<div>
				<NavPublic />
				<h1 className="pt-5">Nouvelle demande d'enlèvement </h1>
				{/* {this.user} */}
				<div className="container public-demande-enlevement">
					<Row className="justify-content-center">
						<Col>
							<FormDemande />
						</Col>
					</Row>
				</div>
			</div>
		);
	}
}

export default AddDemandePublic;
